import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {RegisterContextProvider} from '../../components/RegisterContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import FieldPassword from '../../components/FieldPassword';
import FieldRegisterEmail from '../../components/FieldRegisterEmail';
import FieldPhone from '../../components/FieldPhone';
import FieldConfirmPassword from '../../components/FieldConfirmPassword';
import ButtonRegister from '../../components/ButtonRegister';
import ButtonLink from '../../components/ButtonLink';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import {pathnames as P} from '../../../../common/enums';
import styles from './Register.module.scss';

const Register = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'register-page-header'}
        defaultMessage={'Register'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <RegisterContextProvider>
      <SectionPanel className={styles.registerContainer}>
        <FieldRegisterEmail/>
        <FieldPhone/>
        <FieldPassword/>
        <FieldConfirmPassword/>
        <ButtonRegister/>
        <ButtonLink
          link={P.LOGIN}
          label={
            <FormattedMessage
              id={'register-button-already-registered'}
              defaultMessage={'Already registered in the system? Connect here'}
            />
          }
        />
      </SectionPanel>
      <FooterLogo/>
    </RegisterContextProvider>
  );
};

export default Register;
